import ResourceTyped from 'Resources/ResourceTyped';

export type StandardCreativeType = {
	id: number;
	name: string;
	subject: string;
	body: string;
	active: boolean;
};

class StandardCreative extends ResourceTyped<StandardCreativeType> {
	constructor() {
		super('standardCreative');
	}
}

export default new StandardCreative();
